/**
 * @generated SignedSource<<55c3727632f5663632eee12eed1b6d6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type homeSecondaryContentItemContent$data = {
  readonly " $fragmentSpreads": FragmentRefs<"entityLink">;
  readonly " $fragmentType": "homeSecondaryContentItemContent";
};
export type homeSecondaryContentItemContent$key = {
  readonly " $data"?: homeSecondaryContentItemContent$data;
  readonly " $fragmentSpreads": FragmentRefs<"homeSecondaryContentItemContent">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "homeSecondaryContentItemContent",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "entityLink"
    }
  ],
  "type": "Content",
  "abstractKey": "__isContent"
};

(node as any).hash = "e6fea03ee51d3f5a4d3d7edadcdee165";

export default node;
